import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { PublicLayout } from '@/components/public/PublicLayout';
import { Seo } from '@/components/Seo';
import { Sila3DExplorer } from '@/components/public/Sila3DExplorer';
import { BookingDialog } from '@/components/public/BookingDialog';
import { Button } from '@/components/ui/button';
import { Leaf, Map as MapIcon, MousePointerClick, MapPin } from 'lucide-react';

export default function Parco3D() {
  const [areas, setAreas] = useState([]);
  const [booking, setBooking] = useState({ open: false, area: null });

  useEffect(() => {
    api.get('/parco/public/areas').then(({ data }) => setAreas(data || [])).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <Seo title="Sila 3D Explorer" description="Esplora il Parco Nazionale della Sila in 3D: itinerari luminosi, punti panoramici e prenotazione diretta dei tour." path="/parco-3d" />
      <section className="sila-section pb-8 pt-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-[hsl(var(--brand-sun)/0.22)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[hsl(var(--brand-bark))]"><Leaf className="h-3.5 w-3.5" />Sila 3D Explorer</span>
        <h1 className="mt-4 font-display text-4xl font-bold tracking-tight sm:text-5xl">Esplora la Sila in 3D</h1>
        <p className="mt-3 max-w-2xl text-lg text-muted-foreground">Ruota la mappa, segui gli itinerari luminosi delle guide, apri i punti panoramici e prenota il tuo tour con un clic.</p>
        <div className="mt-4 flex flex-wrap gap-4 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-2"><MapIcon className="h-4 w-4 text-primary" />Terreno reale 3D</span>
          <span className="inline-flex items-center gap-2"><MousePointerClick className="h-4 w-4 text-primary" />Itinerari interattivi</span>
          <span className="inline-flex items-center gap-2"><MapPin className="h-4 w-4 text-primary" />“Tu sei qui” in tempo reale</span>
        </div>
      </section>

      <section className="sila-section pb-10">
        <Sila3DExplorer areas={areas} onBook={(area) => setBooking({ open: true, area })} />
        {areas.length === 0 && (
          <p className="mt-4 rounded-xl border border-dashed border-border bg-muted/40 p-4 text-sm text-muted-foreground" data-testid="parco3d-empty">Nessun itinerario pubblicato al momento. Torna presto: le guide stanno tracciando i primi percorsi.</p>
        )}
      </section>

      <section className="sila-section pb-24">
        <div className="grain-overlay flex flex-col items-start gap-4 rounded-[24px] bg-primary p-8 text-primary-foreground sm:flex-row sm:items-center sm:justify-between">
          <div><h2 className="font-display text-2xl font-bold">Sei una guida?</h2><p className="mt-1 text-primary-foreground/85">Crea il tuo itinerario: apparirà sulla mappa 3D dopo l'approvazione.</p></div>
          <Button asChild size="lg" variant="secondary" className="rounded-full"><Link to="/partner/accedi">Accedi come guida</Link></Button>
        </div>
      </section>

      <BookingDialog open={booking.open} onOpenChange={(o) => setBooking((b) => ({ ...b, open: o }))} area={booking.area} />
    </PublicLayout>
  );
}
